const AutoOrderType = {
  ONE_TIME: {
    index: 0,
    indexServer: -1,
    description: "One time",
    frequenceId: "one-time",
    frequencyText: "",
  },
  EVERY_TWO_WEEKS: {
    index: 1,
    indexServer: 0,
    frequenceId: "weeks-2",
    description: "2 weeks",
    frequencyText: "on the 1st and 15th",
  },
  EVERY_MONTH: {
    index: 2,
    indexServer: 1,
    frequenceId: "months-1",
    description: "month",
    frequencyText: "on the 1st",
  },
  EVERY_TWO_MONTS: {
    index: 3,
    indexServer: 2,
    frequenceId: "months-2",
    description: "2 months",
    frequencyText: "on the 1st",
  },
};

export const getSelectedAutoOrderType = (selectedAutoOrder: number) => {
  switch (selectedAutoOrder) {
    case AutoOrderType.ONE_TIME.index: {
      return AutoOrderType.ONE_TIME;
    }
    case AutoOrderType.EVERY_TWO_WEEKS.index: {
      return AutoOrderType.EVERY_TWO_WEEKS;
    }
    case AutoOrderType.EVERY_MONTH.index: {
      return AutoOrderType.EVERY_MONTH;
    }
    case AutoOrderType.EVERY_TWO_MONTS.index: {
      return AutoOrderType.EVERY_TWO_MONTS;
    }
    default: {
      return AutoOrderType.ONE_TIME;
    }
  }
};

export const getAutoOrderTypeByFrequenceId = (frequencyId: string) => {
  switch (frequencyId) {
    case AutoOrderType.ONE_TIME.frequenceId: {
      return AutoOrderType.ONE_TIME;
    }
    case AutoOrderType.EVERY_TWO_WEEKS.frequenceId: {
      return AutoOrderType.EVERY_TWO_WEEKS;
    }
    case AutoOrderType.EVERY_MONTH.frequenceId: {
      return AutoOrderType.EVERY_MONTH;
    }
    case AutoOrderType.EVERY_TWO_MONTS.frequenceId: {
      return AutoOrderType.EVERY_TWO_MONTS;
    }
    default: {
      return AutoOrderType.ONE_TIME;
    }
  }
};

export const isAutoOrderSubscribedByUser = (subscriptionFutureDates: SubscriptionFutureDatesForProduct[] | null) => {
  return (
    subscriptionFutureDates && subscriptionFutureDates.length == 1 && subscriptionFutureDates[0].SubscriptionId !== null
  );
};
